import { render, staticRenderFns } from "./TurnaroundCreateButton.vue?vue&type=template&id=568bd42a"
import script from "./TurnaroundCreateButton.vue?vue&type=script&lang=js"
export * from "./TurnaroundCreateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports